import React, { useEffect, useState } from "react";
import "./PodcastPlayer.scss";
import { FaSpotify, FaMicrophoneAlt } from "react-icons/fa";

const CHANNEL_ID = "UC4erOuqnjqbmHw08rL9Lwxw";

const PodcastPlayer = () => {
  const [episode, setEpisode] = useState(null);

  useEffect(() => {
    const fetchLatestEpisode = async () => {
      try {
        const response = await fetch(
          `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=${CHANNEL_ID}&maxResults=1&order=date&type=video&key=${process.env.REACT_APP_YOUTUBE_API_KEY}`,
        );

        const data = await response.json();

        if (!data.items || data.items.length === 0) {
          console.error("No hay vídeos en la respuesta");
          return;
        }

        setEpisode(data.items[0]);
      } catch (error) {
        console.error("Error en fetch:", error);
      }
    };

    fetchLatestEpisode();
  }, []);

  if (!episode) return <p>Cargando último episodio...</p>;

  const { title, description } = episode.snippet;
  const videoId = episode.id.videoId;

  return (
    <div className="player">
      <div className="player__video">
        <iframe
          src={`https://www.youtube.com/embed/${videoId}`}
          title={title}
          frameBorder="0"
          allowFullScreen
        />
      </div>

      <div className="player__info">
        <h2>{title}</h2>

        <p className="player__description" data-full={description}>
          {description}
        </p>
      </div>

      <div className="player__links">
        <a
          href="https://open.spotify.com/show/0bl0g59QzCk5Kf1IU4Pxp8?si=fb83ac15b4274b1f"
          target="_blank"
          rel="noreferrer"
          className="player__link"
        >
          <FaSpotify />
          Escuchar en Spotify
        </a>

        <a
          href="https://go.ivoox.com/sq/2485270"
          target="_blank"
          rel="noreferrer"
          className="player__link"
        >
          <FaMicrophoneAlt />
          Escuchar en iVoox
        </a>
      </div>
    </div>
  );
};

export default PodcastPlayer;
